import React, { useContext } from "react";
import styles from "./PosterCreationLanding.module.css";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import Context from "../context/Context";
import PosterInitialSelected from "../Components/PosterInitialSelected/PosterInitialSelected";
import user from "../assests/user.svg";
import { useUserAuth } from "../context/UserAuthContext";
import refreshIcon from "../assests/posterCreation/refreshIconOnly.svg";
import { createSearchParams } from "react-router-dom";
import { isEmpty } from "lodash";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import backIcon from "../assests/posterCreation/backIcon.svg";

function PosterCreation() {
  const { occasion } = useParams();
  const posterInitialData = [
    {
      bgUrl: "https://storage.googleapis.com/goviral_posters/medias/bg1.jpeg",
      sampleUrl:
        "https://storage.googleapis.com/goviral_posters/medias/bg1.jpeg",
      borderColour: "(23, 32, 29)",
    },
    {
      bgUrl: "https://storage.googleapis.com/goviral_posters/medias/bg2.jpeg",
      sampleUrl:
        "https://storage.googleapis.com/goviral_posters/medias/bg2.jpeg",
      borderColour: "(210, 128, 73)",
    },
  ];
  let occasionInitialData = {
    1: {
      coverImage:
        "https://storage.googleapis.com/goviral_posters/medias/bg1.jpeg",
      title: "",
      posterUrl:
        "https://storage.googleapis.com/goviralcampaignmedias/111/285/campaignPoster/1696406282741",
      description:
        "Welcome to the online Poster contest \"Fashion Frame\". We invite participants to upload their photos wearing Seematti clothing inside our showroom, using the provided posters as backdrops. 👗 👚This unique concept not only highlights the elegance of Seematti's collections but also allows participants to express their individuality and flair for fashion. Participants are encouraged to explore different looks and styles, experimenting with Seematti's diverse range of clothing and accessories. Join us in celebrating the magic of fashion and self-expression. 👗 👚",

      participateInContest: false,
      participateWithoutShare: false,
      apis: [
        "https://us-central1-tripsmagic.cloudfunctions.net/changeBackgroundImage",
        "https://asia-south1-tripsmagic.cloudfunctions.net/changeBackgroundImageVersion2",
        "https://asia-south1-tripsmagic.cloudfunctions.net/changeBackgroundImageVersion3",
      ],
      contests: [],
      backgrounds: posterInitialData,
      loadingDatas: {
        slideImages: [],
        song: "",
      },
    },
    events: [
      {
        icon: "https://storage.googleapis.com/goviral_posters/medias/bg1.jpeg",
        key: "1",
      },
    ],
    default: "1",
  };
  const [ocassionData, setOcassionData] = useState({});
  const [popup, setPopup] = useState(false);
  const [popupImageIndex, setPopupImageIndex] = useState("");
  const [eventSelected, setEventSelected] = useState(1);
  const [posterImages, setPosterImages] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    preview,
    setOcassionDataofEvent,
    ocassionDataofEvent,
    details,
    loadHomePageDetails,
    campaignSpecs,
  } = useContext(Context);
  const { currentUser, setPreviousLocation, searchParams } = useUserAuth();
  const [reloadState, setReloadState] = useState(false);
  const mode = window.location.pathname.split("/")[1]?.replace(/\.html$/, "");

  useEffect(() => {
    getPosterBackgrounds();
  }, []);
  useEffect(() => {
    if (ocassionData && ocassionData[eventSelected]) {
      let images = ocassionData[eventSelected]?.backgrounds || [];
      setPosterImages([...images]);
    }
  }, [eventSelected, ocassionData]);
  useEffect(() => {
    if (!isEmpty(ocassionData)) {
      setEventSelected(ocassionData?.default);
    }
  }, [ocassionData]);
  useEffect(() => {
    if (!isEmpty(ocassionDataofEvent)) {
      if (isEmpty(campaignSpecs)) {
        loadHomePageDetails(
          ocassionDataofEvent?.orgDomain,
          ocassionDataofEvent?.campaignUniqueText
        );
      }
    }
  }, [ocassionDataofEvent]);
  useEffect(() => {
    if (!isEmpty(ocassionData)) {
      setOcassionDataofEvent(ocassionData[eventSelected]);
    }
  }, [ocassionData, eventSelected]);

  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/signup`,
          search: "?preview=true",
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    }
  };

  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/profile`,
          search: "?preview=true",
        },
        { state: { previousLocation: location?.pathname } }
      );
    } else {
      navigate(
        {
          pathname: `/profile`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        { state: { previousLocation: location?.pathname } }
      );
    }
  };

  const getPosterBackgrounds = async () => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviral_posters/${occasion}/data.json`
      );
      // const data = await axios.get(`/${occasion}/data.json`)
      setOcassionData(data?.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <>
      <FloatingWidgets
        page="campaign"
        prize={details?.priceDescription}
        endTime={details?.endDate}
        color={details?.btnColor}
        bgColor={details?.bgColor}
      />
      <div className={styles.posterContainer}>
        {popup && (
          <PosterInitialSelected
            visible={popup}
            close={setPopup}
            ocassionData={ocassionData[eventSelected]}
            popupImageIndex={popupImageIndex}
          />
        )}
        <div
          className="w-full h-full"
          style={{
            background: `url(${ocassionData[eventSelected]?.coverImage}) center center / cover`,
          }}
        >
          {/* <NavigationHeader type="campaign" /> */}
          <div className="flex justify-between px-[20px] mt-[20px] mb-[24px]">
            {((ocassionDataofEvent?.orgDomain &&
              ocassionDataofEvent?.campaignUniqueText) ||
              ocassionDataofEvent?.navigateBack) && (
              <img
                className="cursor-pointer bg-white rounded-full w-[40px] h-[40px]"
                src={backIcon}
                alt=""
                onClick={() => {
                  ocassionDataofEvent?.navigateBack
                    ? (window.location.href = `${ocassionDataofEvent?.navigateBack}`)
                    : navigate(
                        `/${ocassionDataofEvent?.orgDomain}/${ocassionDataofEvent?.campaignUniqueText}/${ocassionDataofEvent?.contestUniqueText}.html`
                      );
                  // navigate(
                  //   ocassionDataofEvent?.navigateBack ? `${ocassionDataofEvent?.navigateBack}` : `/${ocassionDataofEvent?.orgDomain}/${ocassionDataofEvent?.campaignUniqueText}`
                  // );
                }}
              />
            )}
            {currentUser ? (
              <>
                <img
                  src={currentUser?.photoURL ? currentUser?.photoURL : user}
                  alt=""
                  className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                  onClick={handleProfileNavigate}
                />
              </>
            ) : (
              <img
                src={user}
                alt=""
                className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                onClick={handleLogin}
              />
            )}
          </div>
          <div className="mt-[40px] mb-[76px] px-[54px]  flex flex-col items-center  ">
            {/* <p className='text-black text-[19px] leading-[24px] font-semibold'>Create a poster in seconds</p> */}
            <div className="flex gap-[16px] items-center w-[200px] justify-center">
              {ocassionData?.events?.map((obj, i) => {
                return (
                  <div key={i}>
                    {obj?.icon && (
                      <button
                        className={styles.filterChipsButton}
                        style={
                          obj?.key === eventSelected
                            ? { backgroundColor: "white", color: "black" }
                            : {}
                        }
                        onClick={() => {
                          setEventSelected(obj?.key);
                        }}
                      >
                        <img
                          src={obj?.icon ? obj?.icon : null}
                          alt=""
                          className="rounded-[16px] object-cover w-full h-full"
                        />
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
            {/* <div>
                        <img
                            src={marineWorldLogo}
                            alt=""
                            className='w-[140px] h-[100px]' />
                    </div> */}
            <p
              className={`${styles.textShadow} text-white font-bold text-[22px] leading-[24px] mt-[8px] capitalize text-center`}
            >
              {ocassionData[eventSelected]?.title}
            </p>
            {/* <p className='text-white font-bold text-[24px] leading-[24px] capitalize text-center'>Underwater tunnel aquarium</p> */}
          </div>
        </div>
        <div className="w-full ">
          <div className={styles.backgroundContainer}>
            <div className="w-full sticky top-0 pt-[24px] pb-[20px] bg-white mb-[10px]">
              <p className="text-black text-center w-full pb-[10px] text-[22px] font-semibold leading-[22px] ">
                {mode == "faceswap" ? "Swap Faces" : "Create Poster"}
              </p>

              <div className="flex  justify-between items-center">
                <p className="text-black text-left  text-[16px] font-semibold leading-[22px] ">
                  {mode == "faceswap"
                    ? "Choose an image"
                    : "Choose your background"}
                </p>
                {/* <img
                src={refreshIcon}
                alt=""
                onClick={() => {
                  window.location.reload();
                }}
                className="cursor-pointer"
              /> */}
                <div
                  onClick={() => {
                    setReloadState(true);
                    window.location.reload();
                  }}
                  className="flex gap-[1px] items-center"
                >
                  <img src={refreshIcon} alt="" className="cursor-pointer" />
                  <p className="text-black text-[12px]">
                    {reloadState
                      ? "Loading..."
                      : mode == "faceswap"
                      ? "Refresh"
                      : "Refresh Background"}
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 w-full gap-[16px] pb-[24px]">
              {!isEmpty(posterImages) ? (
                posterImages?.map((obj, index) => {
                  return (
                    <div key={index} className="aspect-square w-full">
                      <img
                        onClick={() => {
                          setPopup(true);
                          setPopupImageIndex(index);
                        }}
                        src={obj?.sampleUrl ? obj?.sampleUrl : obj?.bgUrl}
                        alt=""
                        className="rounded-[16px] object-cover w-full h-full aspect-square"
                      />
                    </div>
                  );
                })
              ) : (
                <div className="col-span-2 min-h-[20vh] flex items-center justify-center text-center">
                  <p className="text-[12px] text-[#787878] leading-[16px] font-semibold mb-[4px]">
                    "Oops! the background not loaded , please click show
                    background icon to load the background images "
                  </p>
                </div>
              )}
            </div>
            <div className="w-full mb-[32px] px-[40px]">
              <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
            </div>
            <div className=" text-center">
              <p className="text-[12px] text-[#787878] leading-[16px] font-semibold mb-[4px]">
                Powered by
              </p>
              <p className="text-[16px] text-black font-bold  leading-[22px] mb-[10px] ">
                Goviral World Magazine
              </p>
              <p className="text-[13px] text-black leading-[18px] mb-[30px]">
                goviralit@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PosterCreation;
